import React from "react";
import { useParams } from "react-router-dom";
import { ChatContainer } from "@/components/chat/ChatContainer";
import { useRole } from "@/hooks/useRole";

const ChatPage = () => {
  const { conversationId } = useParams<{ conversationId?: string }>();
  const { role } = useRole();

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">Chat</h1>
        <p className="text-gray-400">
          {role === "mentor" ? "Converse com seus alunos" : "Converse com seus mentores"}
        </p>
      </div>
      
      <div className="h-[calc(100vh-18rem)] bg-[#131922] rounded-lg overflow-hidden border border-[#222A35]">
        <ChatContainer initialConversationId={conversationId} />
      </div>
    </div>
  );
};

export default ChatPage; 